import {Injectable} from '@angular/core';
import { OrganisationAdminApiService } from '../../organisation-admin/services/organisation-admin-api-service';

// @Injectable() 
export class ListingOrganisationService extends OrganisationAdminApiService {
  protected endpoint() {
    let endpoint = `listing-admin/organisations`;
    return endpoint;
  }
}
